import { render, staticRenderFns } from "./quotes_list.vue?vue&type=template&id=751b6e16&"
import script from "./quotes_list.vue?vue&type=script&lang=js&"
export * from "./quotes_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports